import styled from "styled-components";

export const StyledTransferWrapper = styled.div`
  .transfer-head {
    padding: 15px 0 25px;
    display: grid;
    align-items: center;
    grid-template-columns: max-content 175px;
    grid-gap: 20px;
    @media screen and (max-width: 599px) {
      grid-template-columns: 100%;
    }
  }

  .transfer-table {
    &__head, &__row {
      grid-template-columns: repeat(3, minmax(250px, 1fr)) repeat(2, minmax(150px, .8fr)) repeat(4, minmax(150px, 1fr)) minmax(200px, 1fr);
    }
    @media screen and (max-width: 992px) {
      min-width: auto;
      overflow-x: inherit;
      &__head {
        display: none;
      }
      &__row {
        margin-bottom: 15px;
        grid-template-columns: repeat(2, 1fr);
        border: 1px solid ${({theme}) => theme.surface.border};
        & > div {
          padding-top: 20px;
          &:before {
            display: block;
          }
        }
      }
      &__note {
        grid-column-start: 1;
        grid-column-end: 3;
      }
    }
    @media screen and (max-width: 599px) {
      &__row {
        padding: 15px 10px;
        grid-template-columns: 100%;
      }
      &__note {
        grid-column-end: 1;
      }
    }
  }
`;